/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* THE CODE BELOW IS FOR HE GCLA About PAGE HERO IMAGE TABS */

(function(){
  const hero = document.getElementById('gcla-hero-img');
  if(!hero) return;

  const IMG = {
    facility: 'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/front_of_Grand_Cru_Liquid_Assets_facility.jpg?v=1760123082',
    tasting:  'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/Grand_Cru_Liquid_Assets_Office.jpg',
    cellar:   'https://cdn.shopify.com/s/files/1/0319/8592/6203/files/secure_wine_cellar.jpg'
  };

  const tabs = Array.from(document.querySelectorAll('.gcla-phototab'));

  function setActive(key){
    const next = IMG[key];
    if (next && hero.src !== next) hero.src = next;
    tabs.forEach(btn =>
      btn.setAttribute('aria-selected', btn.dataset.img === key ? 'true' : 'false')
    );
  }

  // Hover + focus (desktop & keyboard)
  tabs.forEach(btn => {
    const key = btn.dataset.img;
    btn.addEventListener('mouseenter', () => setActive(key));
    btn.addEventListener('focus', () => setActive(key));
  });

  // Touch fallback: click to change
  const isCoarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (isCoarse) {
    tabs.forEach(btn =>
      btn.addEventListener('click', () => setActive(btn.dataset.img))
    );
  }

  // Initialize based on aria-selected
  const initial = tabs.find(b => b.getAttribute('aria-selected') === 'true');
  setActive(initial ? initial.dataset.img : 'tasting');
})();
/* THE CODE ABOVE IS FOR HE GCLA About PAGE HERO IMAGE TABS */

/* Search UX: close search on outside click, keep dim overlay active, and support clear-query action. */
(function () {
  const SEARCH_ID = "Search";

  // Searchanise instant-search containers (treat clicks inside as "inside")
  const SNIZE_SELECTORS = [
    ".snize-ac-results",
    ".snize-ac-results-content",
    ".snize-ac-results-container",
    ".snize-results",
    ".snize-dropdown",
    "[id^='snize-']"
  ].join(",");

  function getSearchEl() {
    return document.getElementById(SEARCH_ID);
  }

  function isSearchOpen(searchEl) {
    return !!searchEl && searchEl.getAttribute("aria-hidden") === "false";
  }

  function getSearchInput(searchEl) {
    return searchEl ? searchEl.querySelector('.Search__Input[name="q"]') : null;
  }

  function getClearBtn(searchEl) {
    return searchEl ? searchEl.querySelector('[data-action="clear-search"]') : null;
  }

  function getOverlayEl() {
    return document.querySelector(".PageOverlay");
  }

  function ensureOverlayVisible(visible) {
    const overlay = getOverlayEl();
    if (!overlay) return;
    overlay.classList.toggle("is-visible", !!visible);
  }

  function focusInput(input) {
    if (!input) return;

    try {
      input.focus({ preventScroll: true });
    } catch (e) {
      input.focus();
    }
  }

  function syncClearButton(searchEl) {
    const input = getSearchInput(searchEl);
    const clearBtn = getClearBtn(searchEl);

    if (!input || !clearBtn) return;

    const visible = input.value.length > 0;

    clearBtn.classList.toggle("is-visible", visible);
    clearBtn.setAttribute("aria-hidden", visible ? "false" : "true");
    clearBtn.tabIndex = visible ? 0 : -1;
  }

  function dispatchSearchResetEvents(input) {
    ["input", "change", "search"].forEach(function (eventName) {
      input.dispatchEvent(new Event(eventName, { bubbles: true }));
    });
  }

  function closeSearch(searchEl) {
    if (!searchEl) return;
    const closeBtn = searchEl.querySelector('[data-action="close-search"]');
    if (closeBtn) closeBtn.click();
  }

  document.addEventListener("input", function (e) {
    const searchEl = getSearchEl();
    if (!searchEl || e.target !== getSearchInput(searchEl)) return;

    syncClearButton(searchEl);
  });

  document.addEventListener("click", function (e) {
    const clearBtn = e.target.closest('[data-action="clear-search"]');

    if (clearBtn) {
      const searchEl = getSearchEl();
      const input = getSearchInput(searchEl);

      if (!searchEl || !input) return;

      e.preventDefault();
      e.stopPropagation();

      input.value = "";
      dispatchSearchResetEvents(input);
      syncClearButton(searchEl);
      focusInput(input);

      return;
    }

    const searchEl = getSearchEl();
    if (!isSearchOpen(searchEl)) return;

    const clickedInsideSearch = e.target.closest("#" + SEARCH_ID);
    const clickedInsideSnize = e.target.closest(SNIZE_SELECTORS);

    // Allow clicking the header search icon/toggle without immediately closing
    const clickedSearchToggle = e.target.closest('[data-action="toggle-search"], [aria-controls="Search"]');

    if (clickedInsideSearch || clickedInsideSnize || clickedSearchToggle) return;

    closeSearch(searchEl);
  });

  // Keep overlay + body search-open state in sync whenever search is open
  function syncOverlay() {
    const searchEl = getSearchEl();
    const open = isSearchOpen(searchEl);

    // Enables your CSS rules (disables mega-menu hover/click while search is open)
    document.body.classList.toggle("search-open", open);

    // Keep the dim overlay visible while search is open
    ensureOverlayVisible(open);

    syncClearButton(searchEl);
  }

  const searchEl = getSearchEl();
  const overlayEl = getOverlayEl();

  if (window.MutationObserver) {
    // Watch the Search container (open/close state changes)
    if (searchEl) {
      const moSearch = new MutationObserver(syncOverlay);
      moSearch.observe(searchEl, {
        attributes: true,
        attributeFilter: ["aria-hidden", "class"]
      });
    }

    // Watch the overlay itself (Searchanise/theme may toggle it after typing)
    if (overlayEl) {
      const moOverlay = new MutationObserver(syncOverlay);
      moOverlay.observe(overlayEl, {
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    }
  }

  // Initial sync
  syncOverlay();
  window.addEventListener("load", syncOverlay);
})();

// Theme 80 PDP UX Update:
// Update Add to Cart button price based on selected quantity,
// and prevent quantity selector from exceeding remaining PDP inventory after cart quantity.
(function () {
  function getRouteRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function fetchCart() {
    return fetch(getRouteRoot() + 'cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat).replace('.00', '');
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function getQuantityInput(row) {
    return row.querySelector('input[name="quantity"]');
  }

  function getQuantity(row) {
    var quantityInput = getQuantityInput(row);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    return quantity > 0 ? quantity : 1;
  }

  function getTotalInventory(row) {
    var quantityInput = getQuantityInput(row);

    if (!quantityInput || !quantityInput.hasAttribute('max')) {
      return null;
    }

    var max = parseInt(quantityInput.getAttribute('max'), 10);

    return max > 0 ? max : null;
  }

  function getCartQuantity(cart, variantId) {
    if (!cart || !cart.items || !variantId) {
      return 0;
    }

    return cart.items.reduce(function (total, item) {
      return String(item.id) === String(variantId) ? total + item.quantity : total;
    }, 0);
  }

  function getRemainingInventory(row) {
    var totalInventory = getTotalInventory(row);
    var cartQuantity = parseInt(row.dataset.cartQuantity || '0', 10);

    if (totalInventory === null) {
      return null;
    }

    return Math.max(totalInventory - cartQuantity, 0);
  }

  function setQuantity(row, quantity) {
    var quantityInput = getQuantityInput(row);
    var remainingInventory = getRemainingInventory(row);
    var safeQuantity = quantity > 0 ? quantity : 1;

    if (remainingInventory !== null && remainingInventory > 0 && safeQuantity > remainingInventory) {
      safeQuantity = remainingInventory;
    }

    if (quantityInput) {
      quantityInput.value = safeQuantity;
    }

    return safeQuantity;
  }

  function setNotice(row, message) {
    var notice = row.parentNode.querySelector('.ProductForm__InventoryNotice');

    if (!notice) {
      return;
    }

    if (message) {
      notice.textContent = message;
      notice.hidden = false;
    } else {
      notice.textContent = '';
      notice.hidden = true;
    }
  }

  function getLimitMessage(row) {
    var totalInventory = getTotalInventory(row);
    var remainingInventory = getRemainingInventory(row);
    var cartQuantity = parseInt(row.dataset.cartQuantity || '0', 10);

    if (totalInventory === null) {
      return '';
    }

    if (remainingInventory <= 0) {
      return 'The maximum available quantity is already in your cart.';
    }

    if (cartQuantity > 0) {
      return 'Only ' + remainingInventory + ' more available. You already have ' + cartQuantity + ' in your cart.';
    }

    return 'Only ' + totalInventory + ' available.';
  }

  function getTooltipMessage(row, controlType) {
  var totalInventory = getTotalInventory(row);
  var remainingInventory = getRemainingInventory(row);
  var cartQuantity = parseInt(row.dataset.cartQuantity || '0', 10);

  if (totalInventory === null) {
    return '';
  }

  if (remainingInventory <= 0) {
    return 'All available items are in your cart.';
  }

  if (controlType === 'increase' && getQuantity(row) >= remainingInventory) {
    if (cartQuantity > 0) {
      return 'Only ' + remainingInventory + ' more available.';
    }

    return 'Maximum quantity selected.';
  }

  return '';
}

function setTooltipMessage(element, message) {
  if (!element) {
    return;
  }

  if (message) {
    element.setAttribute('data-limit-message', message);
  } else {
    element.removeAttribute('data-limit-message');
  }
}

  function updateButtonPrice(row) {
    var addToCartButton = row.querySelector('.ProductForm__AddToCart[data-unit-price]');
    var priceTarget = row.querySelector('.ProductForm__AddToCartPrice');

    if (!addToCartButton || !priceTarget) {
      return;
    }

    var unitPrice = parseInt(addToCartButton.getAttribute('data-unit-price'), 10);
    var moneyFormat = addToCartButton.getAttribute('data-money-format');
    var quantity = getQuantity(row);

    priceTarget.textContent = formatMoney(unitPrice * quantity, moneyFormat);
  }

  function updateButtonStates(row) {
    var addToCartButton = row.querySelector('.ProductForm__AddToCart[data-unit-price]');
    var increaseButton = row.querySelector('[data-action="increase-quantity"]');
    var remainingInventory = getRemainingInventory(row);
    var currentQuantity = getQuantity(row);
    var addToCartLabel = addToCartButton ? addToCartButton.querySelector('span') : null;

    if (addToCartLabel && !addToCartLabel.dataset.originalText) {
      addToCartLabel.dataset.originalText = addToCartLabel.textContent.trim();
    }

    if (increaseButton) {
      if (remainingInventory !== null && currentQuantity >= remainingInventory) {
        increaseButton.classList.add('is-disabled');
        increaseButton.setAttribute('aria-disabled', 'true');
        setTooltipMessage(increaseButton, getTooltipMessage(row, 'increase'));
      } else {
        increaseButton.classList.remove('is-disabled');
        increaseButton.removeAttribute('aria-disabled');
        setTooltipMessage(increaseButton, '');
      }
    }

    if (addToCartButton) {
      if (remainingInventory !== null && remainingInventory <= 0) {
        addToCartButton.classList.add('is-disabled');
        addToCartButton.classList.add('is-cart-maxed');
        addToCartButton.setAttribute('aria-disabled', 'true');

        if (addToCartLabel) {
          addToCartLabel.textContent = 'ALL AVAILABLE IN CART';
        }

        setTooltipMessage(addToCartButton, getTooltipMessage(row, 'addToCart'));
      } else {
        addToCartButton.classList.remove('is-disabled');
        addToCartButton.classList.remove('is-cart-maxed');
        addToCartButton.removeAttribute('aria-disabled');

        if (addToCartLabel && addToCartLabel.dataset.originalText) {
          addToCartLabel.textContent = addToCartLabel.dataset.originalText;
        }

        setTooltipMessage(addToCartButton, '');
      }
    }
  }

  function refreshRow(row, showNotice) {
    var remainingInventory = getRemainingInventory(row);
    var currentQuantity = getQuantity(row);

    if (remainingInventory !== null && remainingInventory <= 0) {
      setQuantity(row, 1);

      if (showNotice) {
        setNotice(row, getLimitMessage(row));
      }
    } else if (remainingInventory !== null && currentQuantity > remainingInventory) {
      setQuantity(row, remainingInventory);

      if (showNotice) {
        setNotice(row, getLimitMessage(row));
      }
    } else if (!showNotice) {
      setNotice(row, '');
    }

    updateButtonPrice(row);
    updateButtonStates(row);
  }

  function refreshCartQuantity(row, callback) {
    var addToCartButton = row.querySelector('.ProductForm__AddToCart[data-variant-id]');

    if (!addToCartButton) {
      if (callback) {
        callback();
      }

      return;
    }

    fetchCart().then(function (cart) {
      row.dataset.cartQuantity = getCartQuantity(cart, addToCartButton.getAttribute('data-variant-id'));
      refreshRow(row, false);

      if (callback) {
        callback();
      }
    });
  }

  function refreshAllBuyRows() {
  document.querySelectorAll('.ProductForm__BuyRow').forEach(function (row) {
    if (row.dataset.priceUpdaterInitialized === 'true') {
      refreshCartQuantity(row);
    }
  });
}

function scheduleCartAwareRefresh() {
  // Rebuy/cart drawer changes can be async, so refresh once quickly and once after the drawer finishes updating.
  window.setTimeout(refreshAllBuyRows, 600);
  window.setTimeout(refreshAllBuyRows, 1600);
}

  function shouldBlockAddToCart(row) {
    var remainingInventory = getRemainingInventory(row);

    if (remainingInventory !== null && remainingInventory <= 0) {
      setNotice(row, getLimitMessage(row));
      refreshRow(row, false);
      return true;
    }

    if (remainingInventory !== null && getQuantity(row) > remainingInventory) {
      setQuantity(row, remainingInventory);
      setNotice(row, getLimitMessage(row));
      refreshRow(row, false);
      return true;
    }

    return false;
  }

  function initBuyRowPriceUpdater() {
    document.querySelectorAll('.ProductForm__BuyRow').forEach(function (row) {
      if (row.dataset.priceUpdaterInitialized === 'true') {
        return;
      }

      row.dataset.priceUpdaterInitialized = 'true';
      row.dataset.cartQuantity = '0';

      var quantityInput = getQuantityInput(row);
      var form = row.closest('form');

      if (!quantityInput) {
        return;
      }

      refreshCartQuantity(row);

      quantityInput.addEventListener('input', function () {
        refreshRow(row, true);
      });

      quantityInput.addEventListener('change', function () {
        refreshRow(row, true);
      });

      row.addEventListener('click', function (event) {
        var increaseButton = event.target.closest('[data-action="increase-quantity"]');
        var decreaseButton = event.target.closest('[data-action="decrease-quantity"]');
        var addToCartButton = event.target.closest('.ProductForm__AddToCart');

        if (increaseButton) {
          var remainingInventory = getRemainingInventory(row);

          if (remainingInventory !== null && getQuantity(row) >= remainingInventory) {
            event.preventDefault();
            event.stopImmediatePropagation();
            setNotice(row, getLimitMessage(row));
            refreshRow(row, false);
            return;
          }

          setTimeout(function () {
            setNotice(row, '');
            refreshRow(row, false);
          }, 0);
        }

        if (decreaseButton) {
          setTimeout(function () {
            setNotice(row, '');
            refreshRow(row, false);
          }, 0);
        }

        if (addToCartButton && shouldBlockAddToCart(row)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (addToCartButton) {
          setTimeout(function () {
            refreshCartQuantity(row);
          }, 900);
        }
      }, true);

      if (form) {
        form.addEventListener('submit', function (event) {
          if (shouldBlockAddToCart(row)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      }

      refreshRow(row, false);
    });
  }

function bindCartRefreshListeners() {
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    // Do not duplicate handling for the PDP buy row itself.
    if (event.target.closest('.ProductForm__BuyRow')) {
      return;
    }

    // Rebuy cart drawer/cart controls usually include "rebuy" in class/id/data attributes.
    // This refreshes PDP availability after cart drawer remove/update actions.
    if (event.target.closest('.rebuy-cart, .rebuy-cart__flyout, .rebuy-cart__flyout-item, [class*="rebuy"], [id*="rebuy"], [data-rebuy-cart], [data-rebuy-component]')) {
      scheduleCartAwareRefresh();
    }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      refreshAllBuyRows();
    }
  });

  window.addEventListener('focus', function () {
    refreshAllBuyRows();
  });
}

function initTheme80BuyRow() {
  initBuyRowPriceUpdater();
  bindCartRefreshListeners();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme80BuyRow);
} else {
  initTheme80BuyRow();
}
})();

/* Theme 81 PDP UX Continued:
   Mobile/tablet critic key tap behavior.
   Tap Critic key to open, tap Critic key again or anywhere else to close. */
(function () {
  var ratingKeyMedia = window.matchMedia('(max-width: 1007px)');

  function closeRatingKeys() {
    var openBlocks = document.querySelectorAll('.ProductMeta__RatingBlock.is-rating-key-open');

    Array.prototype.forEach.call(openBlocks, function (block) {
      block.classList.remove('is-rating-key-open');

      var trigger = block.querySelector('.ProductMeta__RatingKeyTrigger');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (!ratingKeyMedia.matches) {
      return;
    }

    var trigger = event.target.closest('.ProductMeta__RatingKeyTrigger');

    if (trigger) {
      event.preventDefault();

      var block = trigger.closest('.ProductMeta__RatingBlock');
      if (!block) {
        return;
      }

      var shouldOpen = !block.classList.contains('is-rating-key-open');

      closeRatingKeys();

      if (shouldOpen) {
        block.classList.add('is-rating-key-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      return;
    }

    closeRatingKeys();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeRatingKeys();
    }
  });

  if (ratingKeyMedia.addEventListener) {
    ratingKeyMedia.addEventListener('change', closeRatingKeys);
  } else if (ratingKeyMedia.addListener) {
    ratingKeyMedia.addListener(closeRatingKeys);
  }
})();

/* ==========================================================================
   THEME 84 - Rebuy Continue Shopping behavior
   Product pages: send Continue Shopping to Grand Cru Wines collection
   Other pages: keep Rebuy default behavior, usually close cart
   ========================================================================== */

document.addEventListener(
  'click',
  function(event) {
    var continueShoppingButton = event.target.closest(
      '.rebuy-cart .rebuy-cart__continue-shopping-button'
    );

    if (!continueShoppingButton) {
      return;
    }

    var currentPath = window.location.pathname;

    if (currentPath.indexOf('/products/') === 0 || currentPath.indexOf('/collections/') === 0 && currentPath.indexOf('/products/') > -1) {
      event.preventDefault();
      event.stopImmediatePropagation();

      window.location.href = '/collections/grand-cru-wines';
    }
  },
  true
);

/* ==========================================================================
   THEME 94 - Native HubSpot newsletter forms
   ========================================================================== */

(function () {
  var selector = '[data-hubspot-newsletter-form]';
  var embedSrc = 'https://js-na2.hsforms.net/forms/embed/v2.js';

  function renderForms() {
    if (!window.hbspt || !window.hbspt.forms) return;

    Array.prototype.forEach.call(document.querySelectorAll(selector), function (container) {
      if (container.getAttribute('data-hubspot-initialized') === 'true') return;

      var formId = container.getAttribute('data-hubspot-form-id');
      var placement = container.getAttribute('data-hubspot-placement');
      var isHomepage = placement === 'homepage';

      container.setAttribute('data-hubspot-initialized', 'true');

      try {
        window.hbspt.forms.create({
          region: 'na2',
          portalId: '24036706',
          formId: formId,
          target: '#' + container.id,
          cssRequired: '',
          cssClass: isHomepage ? 'Form Newsletter__Inner' : 'Form',
          submitButtonClass:
            'Form__Submit Button Button--primary' +
            (placement === 'footer' ? ' Button--full' : ''),
          submitText: container.getAttribute('data-hubspot-submit-text') || 'Subscribe',

          onFormSubmitted: function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'GCLA_newsletter_signup',
              form_location: window.location.href,
              form_id: formId,
              form_placement: placement
            });
          }
        });
      } catch (error) {
        container.removeAttribute('data-hubspot-initialized');
        console.error('Unable to render HubSpot newsletter form.', error);
      }
    });
  }

  function initNewsletterForms() {
    if (!document.querySelector(selector)) return;

    if (window.hbspt && window.hbspt.forms) {
      renderForms();
      return;
    }

    var script = document.querySelector('script[src*="/forms/embed/v2.js"]');

    if (!script) {
      script = document.createElement('script');
      script.src = embedSrc;
      script.async = true;
      document.head.appendChild(script);
    }

    script.addEventListener('load', renderForms, { once: true });
  }

  initNewsletterForms();
  document.addEventListener('shopify:section:load', initNewsletterForms);
})();